import { $, $$, breakpoint, bodyScroll, focusTrapping, setElementFocus } from 'dlr-utils/helpers';
import createTooltipContent from './createTooltipContent';

const SELECTOR = '.dlr-interactive-body-content';
const INSTANCES = $$(SELECTOR);

const ELEMENT = INSTANCES[0];

const IS_EXPANDED = '--is-expanded';
const IS_COLLAPSED = '--is-collapsed';
const IS_ACTIVE = '--is-active';
const IS_PREVIOUS_ACTIVE = '--is-previous-active';

const contentContainer = $(`${SELECTOR}__content`, ELEMENT);
const tooltipContainer = $(`${SELECTOR}__tooltips`, ELEMENT);
const wysiwyg = $(`${SELECTOR}__wysiwyg`, ELEMENT);
const wysiwygInner = $(`${SELECTOR}__wysiwyg-inner`, ELEMENT);
const loadMoreBtn = $(`${SELECTOR}__content-loadmore a`, ELEMENT);
const wysiwygBtns = $$('button', wysiwyg);

tooltipContainer.innerHTML = wysiwygBtns.map((btn, idx) => {
  const buttonData = { ...btn.dataset, index: idx };
  return createTooltipContent(buttonData);
}).join('');

const closeBtns = $$(`${SELECTOR}__tooltip-close-btn`, ELEMENT);

export default {
  init(GlobalEvents, MessageBus) {
    MessageBus.subscribe('LOADMORE_HANDLER', event => {
      event.preventDefault();

      let currentHeight, newHeight;
      const setHeight = (currentHeight, newHeight) => {
        wysiwyg.style.height = currentHeight + 'px';

        setTimeout(() => {
          wysiwyg.style.height = newHeight + 'px';
          setTimeout(() => wysiwyg.removeAttribute('style'), 350);
        }, 20);
      }

      if ( contentContainer.classList.contains(IS_EXPANDED) ) {
        contentContainer.classList.remove(IS_EXPANDED);
        contentContainer.classList.add(IS_COLLAPSED);
        setTimeout(() => contentContainer.classList.remove(IS_COLLAPSED), 350);
        loadMoreBtn.textContent = 'Show More +';

        currentHeight = wysiwygInner.offsetHeight;
        newHeight = $('p', wysiwyg).offsetHeight;
      } else {
        contentContainer.classList.add(IS_EXPANDED);
        loadMoreBtn.textContent = 'Show Less -';

        currentHeight = $('p', wysiwyg).offsetHeight;
        newHeight = wysiwygInner.offsetHeight;

        setTimeout(() => setElementFocus($$('p', wysiwygInner)[1]), 350);
      }

      setHeight(currentHeight, newHeight);
    });

    MessageBus.subscribe('TOOLTIP_HANDLER', e => {
      e.preventDefault();

      if (e.target.classList.contains(IS_ACTIVE)) { 
        MessageBus.publish('CLOSE_BTN_HANDLER', e);
        return;
       }

      const { target } = e;
      const id = target.getAttribute('data-post-id');
      const targetTooltip = $(`${SELECTOR}__tooltip[data-id="${id}"]`);
      const previousActive = $$(`.${IS_ACTIVE}`, ELEMENT);

      previousActive.forEach((item => {
        item.classList.remove(IS_ACTIVE);
        item.classList.add(IS_PREVIOUS_ACTIVE);
        setTimeout(() => item.classList.remove(IS_PREVIOUS_ACTIVE), 350);
      }));

      target.classList.add(IS_ACTIVE);
      targetTooltip.classList.add(IS_ACTIVE);
      tooltipContainer.classList.add(IS_EXPANDED);

      breakpoint() == 'mobile' && bodyScroll(false);
      focusTrapping(tooltipContainer, true);
      setTimeout(() => $('button', targetTooltip).focus(), 200);
    });

    MessageBus.subscribe('CLOSE_BTN_HANDLER', e => {
      e.preventDefault();

      const previousActive = $$(`.${IS_ACTIVE}`, ELEMENT);
      previousActive.forEach((item => {
        tooltipContainer.classList.remove(IS_EXPANDED);
        item.classList.remove(IS_ACTIVE);
        item.classList.add(IS_PREVIOUS_ACTIVE);
        setTimeout(() => item.classList.remove(IS_PREVIOUS_ACTIVE), 350);

        focusTrapping(tooltipContainer, false);
        item.hasAttribute('data-tooltip-id') && item.focus();
      }));

      breakpoint() == 'mobile' && bodyScroll(true);
    });
  },

  finalize(GlobalEvents, MessageBus) {
    !! loadMoreBtn && loadMoreBtn.addEventListener('click', e => MessageBus.publish('LOADMORE_HANDLER', e));
    closeBtns.forEach(btn => btn.addEventListener('click', e => MessageBus.publish('CLOSE_BTN_HANDLER', e)));

    wysiwygBtns.forEach((btn, index) => {
      btn.classList.add('dlr-interactive-body-content__btn');
      btn.setAttribute('data-tooltip-id', index + 1);
      btn.setAttribute('aria-label', 'Open Tooltip');
      btn.addEventListener('click', e => MessageBus.publish('TOOLTIP_HANDLER', e));
    });
  },
};



// WEBPACK FOOTER //
// ../views/modules/interactive-body-content/interactive-body-content.js